import React, { Component } from 'react';
import { ButtonToolbar, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/lib/ToggleButton'


class NumberIO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      outputValue: '',
      errorValue: '',
      inputFormat: 10,
      outputFormat: 2
    };
    this.handleInputFormatChange = this.handleInputFormatChange.bind(this);
    this.handleOutputFormatChange = this.handleOutputFormatChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputFormatChange(event) {
    this.setState({inputFormat: event});
    this.setState({outputValue: this.getOutputValue(this.state.inputValue, event, this.state.outputFormat)})
  }

  handleInputChange(event) {
    this.setState({inputValue: event.target.value});
    this.setState({outputValue: this.getOutputValue(event.target.value, this.state.inputFormat, this.state.outputFormat)})
  }

  handleOutputFormatChange(event) {
    this.setState({outputFormat: event});
    this.setState({outputValue: this.getOutputValue(this.state.inputValue, this.state.inputFormat, event)})
  }

  getOutputValue(inputValue, inputFormat, outputFormat) {
    return parseInt(inputValue, inputFormat).toString(outputFormat);
  }

  render() {
    return (
      <div>
        {this.props.children}
        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>Input</ControlLabel>
          <ButtonToolbar>
            <ToggleButtonGroup onChange={this.handleInputFormatChange} name="input_format" type="radio" defaultValue={this.state.inputFormat} >
              <ToggleButton value={2}>Base 2</ToggleButton>
              <ToggleButton value={3}>Base 3</ToggleButton>
              <ToggleButton value={4}>Base 4</ToggleButton>
              <ToggleButton value={5}>Base 5</ToggleButton>
              <ToggleButton value={6}>Base 6</ToggleButton>
              <ToggleButton value={7}>Base 7</ToggleButton>
              <ToggleButton value={8}>Base 8</ToggleButton>
              <ToggleButton value={9}>Base 9</ToggleButton>
              <ToggleButton value={10}>Base 10</ToggleButton>
              <ToggleButton value={16}>Base 16</ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>
          <FormControl className="top-buffer" onChange={this.handleInputChange} componentClass="textarea" placeholder="Number Input" />
        </FormGroup>

        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>Output</ControlLabel>
          <ButtonToolbar>
            <ToggleButtonGroup onChange={this.handleOutputFormatChange} name="output_format" type="radio" defaultValue={this.state.outputFormat} >
              <ToggleButton value={2}>Base 2</ToggleButton>
              <ToggleButton value={3}>Base 3</ToggleButton>
              <ToggleButton value={4}>Base 4</ToggleButton>
              <ToggleButton value={5}>Base 5</ToggleButton>
              <ToggleButton value={6}>Base 6</ToggleButton>
              <ToggleButton value={7}>Base 7</ToggleButton>
              <ToggleButton value={8}>Base 8</ToggleButton>
              <ToggleButton value={9}>Base 9</ToggleButton>
              <ToggleButton value={10}>Base 10</ToggleButton>
              <ToggleButton value={16}>Base 16</ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>
          <FormControl className="top-buffer" value={this.state.outputValue} componentClass="textarea" placeholder="Number Output" />
        </FormGroup>
      </div>
    );
  }
}

export default NumberIO;



// WEBPACK FOOTER //
// ./src/components/NumberIO/NumberIO.js